import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { ReportEntity } from './report'

export class ReportsRepository extends BaseRepository<ReportEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/reports', token, cache)
    }
}
